import { NATION_SHORT } from "@dominoapp/core-utils";
import { StockInfoDTO } from "@src/common/types/stockInfo.type";
import {
  stockDetailNameFormat,
  stockDetailSymbolFormat,
} from "@src/common/utils/strings/format";

export const getMetaTagName = (stockInfoData: StockInfoDTO) => {
  const { nameKr, nameEn, symbol, type, nation, symbolAlter } = stockInfoData;
  const title = stockDetailNameFormat(nameKr, nameEn || "");
  const subTitle = stockDetailSymbolFormat(
    type,
    nation,
    symbol,
    symbolAlter || "",
  );

  return nation === NATION_SHORT.KR
    ? subTitle
      ? `${title}(${subTitle})`
      : title
    : `${subTitle}(${title})`;
};

export const getMetaTagDescription = (stockInfoData: StockInfoDTO) => {
  const { nameKr, nameEn, type } = stockInfoData;
  const title = stockDetailNameFormat(nameKr, nameEn || "");

  switch (type) {
    case "STOCK":
      return `${title}의 장중 실시간 차트 및 프리·애프터 시세를 확인하세요. 보유 종목이라면 내 자산으로 등록하여 실시간 자산 변동 내역을 확인할 수 있어요.`;
    case "FUND":
      return `${title}의 최신 가격 및 차트를 확인하세요. 보유 종목이라면 내 자산으로 등록하여 실시간 자산 변동 내역을 확인할 수 있어요.`;
    case "KR_APT":
      return `${title}의 최근 실거래가를 확인하세요. 보유 자산이라면 내 자산으로 등록하여 실시간 자산 변동 내역을 확인할 수 있어요.`;
    case "CRYPTO":
      return `${title}의 장중 실시간 차트를 확인하세요. 보유 종목이라면 내 자산으로 등록하여 실시간 자산 변동 내역을 확인할 수 있어요.`;
  }
};
